var _a, _b;
const config = JSON.parse((_b = (_a = document.getElementById("app-config")) === null || _a === void 0 ? void 0 : _a.textContent) !== null && _b !== void 0 ? _b : "{}");
export default config;
